import { mapActions, mapGetters } from 'vuex'
import WidgetGallery from '@components/WidgetGallery/WidgetGallery.vue'
import WidgetTrafficShareForm
  from '@components/forms/WidgetTrafficShareForm.vue'
import { CAMPAIGN_TYPE } from '@meta/campaignConstants'

export default {
  name: 'WidgetGalleryModal',
  props: {
    widgetGalleryModalVisible: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    'widget-gallery-component': WidgetGallery,
    'widgets-traffic-share-form-component': WidgetTrafficShareForm,
  },
  computed: {
    ...mapGetters('templates', [
      'allTemplatesForSelectedTheme',
    ]),
    targetCampaign() {
      return this.$store.getters['campaign/targetCampaign']
    },
    showTrafficShareForm() {
      return this.targetCampaign.type === CAMPAIGN_TYPE.AB
    },
    targetWidgetID() {
      return this.$store.state.campaign.widget.targetWidgetID
    },
  },
  methods: {
    ...mapActions('campaign', ['partialSaveCampaign']),
    ...mapActions('campaign/widget', ['createWidget', 'cloneWidget']),
    triggerAddWidget(id) {
      if (id != null) {
        this.createWidget({ id }).then(() => {
          this.setCampaignType(CAMPAIGN_TYPE.AB).then(() => {
            // console.log('success')
          })
        })
      }
    },
    triggerCloneWidget() {
      const id = this.targetWidgetID

      this.cloneWidget({ id, index: 1 }).then(() => {
        this.setCampaignType(CAMPAIGN_TYPE.AB).then(() => {
          // console.log('success')
        })
      })
    },
    setCampaignType(newType) {
      return this.partialSaveCampaign({ type: newType })
    },
    handleCloseForm() {
      this.closeModal()
    },
    closeModal() {
      this.$emit('close-modal')
    },
  },
}
